import { useMemo } from 'react';
import { ReportingILSStrategyBuilder } from 'customer-data-filters-ui/public/strategies';
import { hasObjectTypeId } from '../../../utils/source-utils';
import DSFieldRecord from 'customer-data-filters/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import { toPropertyBasicType } from '../../../../dataset/type-utils';
import { useFilterRelevantUserInfo } from '../../../../shared/lib/utils';
import { MIGRATE_LEGACY_ILS_DATE_TIME_FILTERS } from 'reporting-data/constants/gates';
export const useDatasetFilterStrategy = ({
  source
}) => {
  const datasetFields = source.getIn(['dataset', 'fields']);
  const dataType = hasObjectTypeId(source) ? source.objectTypeId : source.dataSourceId;
  const {
    userGates
  } = useFilterRelevantUserInfo();
  const strategy = useMemo(() => {
    if (!userGates || !userGates.length) {
      return null;
    }
    // Convert to correct DSFieldRecordType
    const updatedProps = datasetFields.map(field => {
      return DSFieldRecord({
        name: field.name,
        label: field.label,
        type: toPropertyBasicType(field.type)
      });
    });
    return ReportingILSStrategyBuilder({
      getField: (_, id, originalField) => {
        return updatedProps.get(id) || originalField;
      },
      getFields: () => updatedProps,
      getFilterFamilyName: () => dataType,
      getFilterFamilyObjectName: () => dataType,
      reportingFilterContext: 'snowflake_expression',
      supportsLegacyILSDateTimeFilters: !userGates.includes(MIGRATE_LEGACY_ILS_DATE_TIME_FILTERS),
      isIncludeObjectsWithNoValueSetCheckboxEnabled: true
    });
  }, [dataType, datasetFields, userGates]);
  return strategy;
};